import { FadeLoader } from "react-spinners";

const LoadingModal = ({ open }) => {
  if (!open) return null; // Jika tidak open, tidak ada yang dirender.

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50 gap-3">
      <div className="scale-57">
        <FadeLoader height={10} width={5} color="#26a0fc" />
      </div>
      <div className="text-sm" style={{ fontFamily: "Poppins" }}>
        Sedang memuat. . .
      </div>
    </div>
  );
};

LoadingModal.displayName = "LoadingModal";
export { LoadingModal };
